import { render, staticRenderFns } from "./DrugAllocationCart.vue?vue&type=template&id=0044bdc2&scoped=true&"
import script from "./DrugAllocationCart.vue?vue&type=script&lang=js&"
export * from "./DrugAllocationCart.vue?vue&type=script&lang=js&"
import style0 from "./DrugAllocationCart.vue?vue&type=style&index=0&id=0044bdc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0044bdc2",
  null
  
)

export default component.exports